import { TreatmentShadeSet } from 'app/core/models';

export const ShadeTypes = {
  primarySet: 1,
  backupSet: 2,
  unfinishedSet: 3,
  nightGuardSet: 4,
};

export const TreatmentShadeSets: TreatmentShadeSet[] = [
  {
    id: ShadeTypes.primarySet,
    title: 'Primary set',
    price: null,
    priceLabel: 'included',
    currency: 'USD',
    quantity: 2,
    imagePath: '/assets/images/treatment-type-images/moment.svg',
    hasContent: true,
    canDelete: false,
    addDetails: {
      title: 'Add a primary set',
      showPrice: true,
    },
    dismissDetails: {
      title: 'Ready for the unexpected? Add a backup copy of veneers',
      description: 'Add a backup set to avoid costly reorders.',
      dismiss: true,
    },
    enable: true,
    state: 0,
    selectedId: 1,
  },
  {
    id: ShadeTypes.backupSet,
    title: 'Backup set',
    price: 250,
    priceLabel: '',
    currency: 'USD',
    quantity: 1,
    imagePath: '/assets/images/treatment-type-images/moment.svg',
    hasContent: true,
    canDelete: true,
    addDetails: {
      title: 'Add a backup set',
      showPrice: true,
    },
    dismissDetails: {
      title: 'Ready for the unexpected? Add a backup copy of veneers',
      description: 'Add a backup set to avoid costly reorders.',
      dismiss: true,
    },
    enable: true,
    state: 0,
    selectedId: 1,
  },
  {
    id: ShadeTypes.unfinishedSet,
    title: 'Unfinished',
    price: 0,
    priceLabel: '',
    currency: 'USD',
    quantity: 2,
    imagePath: '/assets/images/treatment-type-images/moment.svg',
    hasContent: true,
    canDelete: true,
    addDetails: {
      title: 'Add an unfinished set',
      showPrice: true,
    },
    dismissDetails: {
      title: 'Ready for the unexpected? Add an unfinished of veneers',
      description: 'Add an unfinished set to avoid costly reorders.',
      dismiss: true,
    },
    enable: true,
    state: 0,
    selectedId: 1,
  },
  {
    id: ShadeTypes.nightGuardSet,
    title: 'Night guard',
    price: 100,
    priceLabel: '',
    currency: 'USD',
    quantity: 1,
    imagePath: '/assets/images/treatment-type-images/occlusal-guard.webp',
    hasContent: false,
    canDelete: true,
    addDetails: {
      title: 'Add a night guard',
      showPrice: true,
    },
    dismissDetails: {
      title: `Protect your patient's investment with a night guard`,
      description: `A night guard helps protect your patient's new smile investment.`,
      dismiss: true,
    },
    enable: false,
    state: 0,
    selectedId: 1,
  },
];

/**
 * Crystal uses the Veneer primary shade options with a single copy.
 */
export function getCrystalPrimaryShadeSets(): TreatmentShadeSet[] {
  return TreatmentShadeSets.filter(shadeSet => shadeSet.id === ShadeTypes.primarySet).map(shadeSet => ({
    ...shadeSet,
    quantity: 1,
    addDetails: { ...shadeSet.addDetails },
    dismissDetails: { ...shadeSet.dismissDetails },
  }));
}
